import { useBreakpoint } from '$hooks/index';
import {
  getAssetFromAssetList,
  getSourceFromFields,
} from '$providers/Assets/index';

export function StandardAssetRaw(props: Array<any>) {
  const assets = [...props];
  const [breakpoint] = useBreakpoint();

  if (!breakpoint) return null;

  const asset = getAssetFromAssetList({ assets, breakpoint });
  return getSourceFromFields({ asset });
}
